import React from "react";
import Tabs from "./Tabs";
export default function GlobalConfiguration() {
  return <Tabs />;
}
